import { FC, useMemo, useContext, PropsWithChildren } from 'react';
import useMasterGroups from '@/hooks/data/useMasterGroups';
import MasterGroupsContext from '@/contexts/data/MasterGroupsContext';
import { QueryMasterGroupsResponse } from '@/api/dtos';
import IsLoading from '@/components/layouts/IsLoading';
import TrialContext from '@/contexts/data/TrialContext';


export interface IMasterGroupsProviderProps {
    initial?: QueryMasterGroupsResponse;
}

export const MasterGroupsProvider: FC<PropsWithChildren<IMasterGroupsProviderProps>> = ({ initial, children }) => {
    const { data: trial } = useContext(TrialContext);
    const context = useMasterGroups(trial ? {trialId: trial.id} : undefined, { revalidateOnFocus: false, fallbackData: initial});

    return (

        <MasterGroupsContext.Provider value={context}>
            <IsLoading name="master-groups" loading={context.loading} validating={context.validating}/>
            {children}
        </MasterGroupsContext.Provider>
    );
}

export default MasterGroupsProvider;
